import React, { useState, useEffect, useRef } from "react";
import {
  Avatar,
  Box,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { TabContainer } from "../../../component/organism";
import {
  SignUpForm,
  CourseWalkthroughModal,
} from "../../../component/molecule";
import {
  CircularWithValueLabel,
  DialogComponent,
  DurationButton,
  IconButtonComponent,
  RadioButtonComponent,
  StarRatingoComponent,
} from "../../../component/atom";
import HeadingComponent from "../../../component/atom/Headings/Heading";
import { Actions } from "../../../core/modules/Actions";
import { connect, useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import {
  APPROXIMATESIGN,
  DEFAULT_CURRENCY,
  IMAGE_URL,
  REGISTRED_COURSE_STATUS,
  THEME_COLORS,
  WALKTHROUGH_VIDEO_STATUS,
  getText,
  onGetCurrencySymble,
} from "../../../core/Constant";
import { HeaderStudent } from "../../../component/organism/Header";
import { renderTruncatedText } from "../../../core/Constant";
import TextButtonComponet from "../../../component/atom/Buttons/TextButton";
import moment from "moment";

const CourseDetailsScreen = ({
  getCousreDetails,
  coursedetails,
  course,
  getcourseProgress,
  courseprogress,
  systemCurrency,
  getSystemCurrency,
  documentList,
  getDocumentList,
  show,
  markWalkthroughAsSeen,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [courseID, setCourseId] = useState("");
  const [courseData, setCourseData] = useState();
  const [progress, setProgress] = useState([]);
  const [isRegistered, setIsRegistered] = useState(true);
  const [imgWidth, setImgWidth] = useState(0);
  const [currency, setCurrency] = useState([])
  const [symbol, setSymbol] = useState()
  const [price, setPrice] = useState(0);
  const [currencyList, setCurrencyList] = useState([]);
  const [currencyValue, setCurrencyValue] = useState('');
  const [isShow, setIsShow] = useState(0);
  const [documents, setDocuments] = useState([])
  const [signup, setSignUp] = useState(false);
  const dispatch = useDispatch();
  const [selectedCourse, setSelectedCourse] = useState({});
  const [selectedPlan, setSelectedPlan] = useState();
  const [selectedCurrency, setSelectedCurrency] = useState()
  const [isViewMorePlans, setViewMorePlans] = useState(false)
  const [isExpired, setExpired] = useState(true)
  const [duration, setDuration] = useState("")
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  const isShowApproxiSign = selectedCurrency?.currency !== DEFAULT_CURRENCY
  

  const initCourse = useSelector((state) => state.guest.get("initCourse"));
  const topBannerCourses = useSelector((state) =>
    state.guest.get("topBannerCourses"),
  );

  const currentCourse = coursedetails?.[0];
  const walkthroughVideo = currentCourse?.walkthrough_video_url || currentCourse?.walkthrough_video;
  const isWalkthroughMandatory = Number(currentCourse?.is_walkthrough_video_mandatory) === 1;
  const walkthroughVideoUrl = walkthroughVideo
    ? (typeof walkthroughVideo === "string" && (walkthroughVideo.startsWith("http://") || walkthroughVideo.startsWith("https://") || walkthroughVideo.startsWith("blob:"))
      ? walkthroughVideo
      : IMAGE_URL + walkthroughVideo)
    : "";

  useEffect(() => {
    let list = [...topBannerCourses, ...initCourse];
    const id = location?.state?.course_id;
    const obj = _.find(list, (item) => item.id == id);
    setSelectedCourse(obj);
  }, [topBannerCourses, initCourse]);

  const onRegister = (params) => {
      dispatch(Actions.course.registerNewCourseByUser(params))
  }

  const onEnroll = () => {
    const isFree = courseData?.is_free;
    if (isFree || !isShow) {
      onRegister({
        course_id: courseID,
        course_currency_id: selectedPlan?.id,
        is_free: isFree || !isShow
      });
    } else {
      setSignUp(true);
    }
  };


  useEffect(() => {
    setIsShow(show == 1);
  }, [show]);

  useEffect(() => {
    const currency = localStorage.getItem("GlobalCurrency")
    if (currency) {
      const list = _.map(systemCurrency, (item, index) => {
        return {
          id: item.id,
          currency: item.currency,
          currency_name: item.currency_name,
        };
      });
      const selectedCurrency = list?.find((curnncy) => curnncy?.id?.toString() === currency?.toString())
      setCurrencyList(list);
      setCurrencyValue(selectedCurrency?.id);
    } else {
      const list = _.map(systemCurrency, (item, index) => {
        return {
          id: item.id,
          currency: item.currency,
          currency_name: item.currency_name,
        };
      });
      setCurrencyList(list);
      setCurrencyValue(list[0]?.id);
    }
  }, [systemCurrency]);

  useEffect(() => {
    const courseDetails = location?.state;
    const course = coursedetails?.[0];
    const registered = course?.is_registered !== undefined ? course?.is_registered : courseDetails?.is_registered;
    setIsRegistered(registered);
    setImgWidth(registered ? 750 : 1150);
    setCourseData(courseDetails?.course);
    setCourseId(courseDetails?.course_id);
    const isExpired = course?.is_expired
    const shouldOpenWalkthrough = course?.is_registered === REGISTRED_COURSE_STATUS?.REGISTRED && !isExpired && course?.seen_walkthrough_video === WALKTHROUGH_VIDEO_STATUS.UNSEEN;
    setIsVideoModalOpen(shouldOpenWalkthrough);
    if (coursedetails?.length > 0 && courseDetails?.selectedPlan) {
      const course = coursedetails?.[0]
      const selectedPlan = course?.course_currencies?.find((cc) => cc?.id?.toString() === courseDetails?.selectedPlan?.id?.toString())
      setSelectedPlan(selectedPlan || course?.course_currencies?.[0]);
    }
  }, [location, coursedetails])

  useEffect(() => {
    if (currencyValue && currencyList?.length > 0 && courseID) {
      const selectedCurrency = currencyList?.find((c) => c?.id?.toString() === currencyValue?.toString())
      setSelectedCurrency(selectedCurrency)
      const currencyCode = selectedCurrency?.currency
      getCousreDetails({ courseID, currencyCode });
    }
  }, [currencyValue, currencyList, courseID])

  useEffect(() => {
    if (courseID) {
      getCousreDetails({ courseID, currencyCode: selectedCurrency?.currancy });
      getDocumentList(courseID);
    }
  }, [courseID]);

  useEffect(() => {
    setDocuments(documentList)
  }, [documentList])

  useEffect(() => {
    getcourseProgress();
    getSystemCurrency()
  }, []);

  useEffect(() => {
    let newcurrancyId = localStorage.getItem('GlobalCurrency');
    setCurrencyValue(newcurrancyId)
  }, [])

  useEffect(() => {
    const obj = _.find(courseprogress, (item) => item?.course_id == courseID);
    setProgress(obj);
  }, [courseprogress, courseID]);

  useEffect(() => {
    if (coursedetails?.length > 0) {
      const course = coursedetails?.[0]
      const isRegistred = course?.is_registered
      const isExpired = course?.is_expired
      setExpired(isExpired)
      if (isRegistred !== undefined) {
        setIsRegistered(isRegistred);
        setImgWidth(isRegistred ? 750 : 1150);
      }
      if (isRegistred === 1 && !isExpired) {
        if (course?.duration) {
          setDuration(course?.duration || "")
        } else {
          const enrolledPlan = course?.course_currencies?.find((plan) => plan?.is_enrolled)
          setDuration(enrolledPlan?.duration_weeks || "")
        }
      } else {
        if (course?.duration) {
          setDuration(course?.duration || "")
        } else {
          setDuration(selectedPlan?.duration_weeks || "")
        }
      }
      if (course?.course_currencies?.length > 0 && selectedPlan) {
        const plan = course?.course_currencies?.find((cc) => cc?.id?.toString() === selectedPlan?.id?.toString())
        setSelectedPlan(plan)
        if (plan) {
          const currencySymbol = onGetCurrencySymble(_.get(plan, "currency.currency"));
          const price = _.get(plan, "price", "");
          setPrice(price)
          setSymbol(currencySymbol)
        } else {

        }
      }
    }
  }, [coursedetails, currencyValue, selectedPlan]);

  const onCurrancyChange = (e) => {
    const Selectedvalue = getText(e);
    setCurrencyValue(Selectedvalue);

    localStorage.setItem("GlobalCurrency", Selectedvalue)
  };

  const handleRadioChange = (event, plans) => {
    const text = getText(event);
    const selectedPlan = plans?.find((plan) => plan?.id?.toString() === text?.toString());
    setSelectedPlan(selectedPlan);
  };

  const handleWalkthroughCloseOrEnded = () => {
    const idToMark = courseID || currentCourse?.id || coursedetails?.[0]?.id || location?.state?.course_id;
    if (idToMark) {
      markWalkthroughAsSeen(idToMark);
    }
    setIsVideoModalOpen(false);
  };

  return (
    <>

      <Box>
        <Box>
          <IconButtonComponent
            onclick={() => navigate("/course-catalog")}
            btnType="backbtn"
            btnText="Back"
          />
        </Box>
        {coursedetails.map((item, index) => {
          return (
            <Grid container flexDirection={"column"} rowGap={2} key={index + 1}>
              <Grid item>
                <HeadingComponent
                  text={"Course Details"}
                  fontweigth={600}
                  size={26}
                  fontfamily={"Montserrat"}
                />
                {isShow && (!isRegistered || isExpired) && courseData?.is_free == 0 ?
                  <HeaderStudent dashboard={true} onCurrancyChange={onCurrancyChange} currancy={currencyValue} newcurrancyList={currencyList} />
                  : null}
              </Grid>
              <Grid item>
                <Grid container xs={12} columnGap={2} flexDirection="row" wrap="nowrap" alignItems="stretch">
                  <Grid item xs style={{ minWidth: 0 }}>
                    <Avatar
                      src={IMAGE_URL + item?.course_image}
                      alt="course"
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        borderRadius: 10,
                        height: 220,
                      }}
                    />
                  </Grid>
                  {isRegistered ? (
                    <Grid item sx={{ flexShrink: 0 }}>
                      <div
                        style={{
                          height: "100%",
                          padding: 10,
                          borderRadius: 15,
                          display: "flex",
                          justifyContent: "center",
                          backgroundColor: "rgba(152, 52, 240, 0.2)",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <p
                            style={{
                              fontFamily: "Montserrat",
                              fontSize: "14px",
                              fontWeight: 800,
                              textAlign: "center",
                              margin: "0 0 8px 0",
                            }}
                          >
                            Course progress
                          </p>
                          <CircularWithValueLabel
                            text={progress?.progress + "%"}
                            progress={progress?.progress}
                          />
                        </div>
                      </div>
                    </Grid>
                  ) : null}
                </Grid>
              </Grid>
              <Grid item>
                <Grid container xs={12} justifyContent={'space-between'} alignItems={'center'}>
                  <Grid item>
                    <span
                      style={{
                        color: " #2d3945",
                        fontSize: 22,
                        fontWeight: 800,
                        fontFamily: "Montserrat",
                      }}
                    >
                      {renderTruncatedText(item?.name, { limit: 70 })}
                    </span>
                    <Box sx={{ display: "flex" }}>
                      <Box>
                        <StarRatingoComponent
                          readOnly={true}
                          selectValue={item?.averageRating}
                        />
                      </Box>
                      <Box>
                        <p
                          style={{
                            color: "#4a6375",
                            fontFamily: "Montserrat",
                            marginLeft: 10,
                          }}
                        >
                          {item?.totalRatingCount < 10
                            ? "0" + item?.totalRatingCount
                            : item?.totalRatingCount}
                          Reviews
                        </p>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item>
                    <Grid container columnGap={1}>
                      {item?.is_free === 0 &&
                        (item?.is_registered === 0 || item?.is_expired) &&
                        item?.course_currencies?.length > 0 && (
                          <Grid item>
                            <Box
                              display={"flex"}
                              alignItems={"center"}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                bgcolor: THEME_COLORS.gray4,
                                borderRadius: 2,
                                pr: 1,
                              }}
                            >
                              {item?.course_currencies?.slice(0, 2)?.map((plan) => {
                                const planName = plan?.plan_name || "";
                                const needsTooltip = planName?.length > 40;
                                const displayedText = needsTooltip
                                  ? `${planName?.substring(0, 40)}...`
                                  : planName;
                                return (
                                  <Box display={"flex"} alignItems={"center"}>
                                    {
                                      (planName || (plan?.batch_month && plan?.batch_year)) && <RadioButtonComponent
                                      checked={
                                        selectedPlan?.id?.toString() ===
                                        plan?.id?.toString()
                                      }
                                      value={plan?.id?.toString()}
                                      handleChange={(event) => {
                                        handleRadioChange(event, item?.course_currencies);
                                      }}
                                    />
                                    }
                                    
                                    <p
                                      style={{
                                        fontFamily: "Montserrat, sans serif",
                                        fontSize: "100%",
                                        padding: 0,
                                        margin: 0,
                                        color: "#2d3945",
                                      }}
                                    >
                                      {needsTooltip ? (
                                        <Tooltip title={planName} placement="top" arrow>
                                          <span style={{ cursor: "pointer" }}>
                                            {displayedText}
                                          </span>
                                        </Tooltip>
                                      ) : (
                                        displayedText
                                      )}
                                    </p>
                                    <span
                                      style={{
                                        fontFamily: "Montserrat",
                                        fontWeight: 800,
                                        fontSize: 15,
                                        color: "#2d3945",
                                      }}
                                    >
                                      {
                                        planName ? " -" : ""
                                      }
                                      {` ${plan?.batch_month ? moment()
                                        .month(Number(plan?.batch_month) - 1)
                                        .format("MMMM") : "" } ${plan?.batch_year ? plan?.batch_year : "" }`}
                                    </span>
                                  </Box>
                                );
                              })}
                              {item?.course_currencies?.length > 2 && (
                                <Box display={"flex"} alignItems={"center"} mr={1}>
                                  <Box
                                    sx={{
                                      pl: 2,
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setViewMorePlans(true)
                                      setSignUp(true);
                                    }}
                                  >
                                    <Typography
                                      component="span"
                                      color={THEME_COLORS.primary}
                                      fontWeight={700}
                                      fontSize={16}
                                    >
                                      View More
                                    </Typography>
                                  </Box>
                                </Box>
                              )}
                            </Box>
                          </Grid>
                        )}
                      <Grid item 
                        sx={{
                          marginTop:{
                            xs: 1,
                            sm:1,
                            md:1,
                            lg:"0px"
                          }
                        }}
                      >
                        {isShow ? courseData?.is_free == 1 ? <DurationButton
                          title={"Price"}
                          subtitle={'Free'}
                        /> : <>{isRegistered == 0 || isExpired ? <DurationButton
                          title={"Price"}
                          subtitle={`${price && isShowApproxiSign ? APPROXIMATESIGN : ""}${symbol}${price}`}
                        /> : null}</> : null}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {
                (isRegistered === 0 || isExpired) && <Grid item mt={0}>
                  <Grid
                    container
                    mt={0}
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "flex-end",
                      marginTop: "0px",
                    }}
                  >
                    <Grid>
                      <TextButtonComponet
                        text={"Enroll now"}
                        classStyle={"btn btn-enroll"}
                        onButtonClick={() => {
                          setViewMorePlans(false)
                          onEnroll()
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              }
              <Grid item>
                <TabContainer documentData={documents} data={course} selectedPlan={selectedPlan} handleRadioChange={handleRadioChange} isExpired={isExpired} selectedCurrency={selectedCurrency} />
              </Grid>
            </Grid>
          );
        })}
      </Box>
      <DialogComponent
        isShowCloseButton={false}
        border={30}
        open={signup}
        backgroundColor="#fff"
        onClose={() =>{ 
          setSignUp(false) 
          setViewMorePlans(false)
          const oldSelectedPlan = { ...selectedPlan }
          setSelectedPlan("")
          setSelectedPlan(oldSelectedPlan)
        }}
      >
        <SignUpForm
          isRegistered={true}
          selectedCurrencyOp={selectedCurrency}
          stepIndex={1}
          isViewMorePlans={isViewMorePlans}
          cardSelectedPlan={selectedPlan}
          item={coursedetails?.[0]}
          onClose={() =>{ 
            setSignUp(false)
            setViewMorePlans(false)
            const oldSelectedPlan = { ...selectedPlan }
            setSelectedPlan("")
            setSelectedPlan(oldSelectedPlan)
          }}
        />
      </DialogComponent>

      <CourseWalkthroughModal
        open={isVideoModalOpen}
        videoUrl={walkthroughVideoUrl}
        isMandatory={isWalkthroughMandatory}
        onClose={handleWalkthroughCloseOrEnded}
        onEnded={handleWalkthroughCloseOrEnded}
        courseName={currentCourse?.name}
      />
    </>
  );
};

export default connect(
  (state) => ({
    coursedetails: state.course.get("coursedetails"),
    course: state.course.get("course"),
    courseprogress: state.home.get("courseprogress"),
    systemCurrency: state.auth.get("systemCurrency"),
    show: state.common.get('show'),
    documentList: state.document.get("documentList"),
  }),
  {
    getCousreDetails: Actions.course.getCousreDetails,
    verifyToken: Actions.auth.verifyToken,
    getcourseProgress: Actions.home.getcourseProgress,
    getSystemCurrency: Actions.auth.getSystemCurrency,
    getDocumentList: Actions.document.getDocumentList,
    markWalkthroughAsSeen: Actions.course.markWalkthroughAsSeen,
  }
)(CourseDetailsScreen);


